





































import { Component, Vue, Watch } from 'vue-property-decorator'
import SearchRow from '@/components/SearchRow.vue'
import SearchResult from '@/components/SearchResult.vue'
import searchApiClient from '@/services/SearchApiClient/SearchApiClient'
import searcherryStore from '@/services/Searcherry/SearcherryStore'
import { Route } from 'vue-router'
import searcherryConfig from '@/services/Searcherry/SearcherryConfig'
import searcherry from '@/services/Searcherry/Searcherry'
import { ExitEventData } from '@/services/Statistic/PostData'
import routerProvider from '@/router'

@Component({
  name: 'search-page',
  components: { SearchResult, SearchRow }
})
export default class SearchPage extends Vue {
  searchPhrase = ''
  srchrryTrnBg = ''
  srchrryTrnWr = ''
  categoryId = 0
  searchResults: any = []
  globalStore = searcherryStore
  widgetMode = searcherryConfig.widgetMode
  widgetStyle = searcherryConfig.widgetStyle
  isSearchRowFixed = searcherryConfig.isSearchRowFixed
  isAnimationEnabled = searcherryConfig.isAnimationEnabled

  created () {
    let scrollWidth = window.innerWidth - document.documentElement.clientWidth
    document.body.style.paddingRight = scrollWidth === 0 ? null : scrollWidth + 'px'
    document.documentElement.classList.add('_srchrry-open')
    this.srchrryTrnBg = this.isAnimationEnabled ? 'srchrry-trn-bg' : ''
    this.srchrryTrnWr = this.isAnimationEnabled ? 'srchrry-trn-wr' : ''
    this.init(this.$route)
    this.fetchData()
  }

  mounted () {
    setTimeout(function () {
      searcherry.generateEvent('dom-ready')
    }, 10)
  }

  destroyed () {
    searcherry.generateEvent('before-close')
    setTimeout(function () {
      document.body.style.paddingRight = null
      document.documentElement.classList.remove('_srchrry-open')
      searcherry.generateEvent('after-close')
    }, 300)
  }

  @Watch('$route')
  onRouteChanged (to: Route, from: Route) {
    this.init(to)
    this.fetchData()
  }

  @Watch('searchResults')
  onSearchResultsChanged (to: any, from: any) {
    this.globalStore.setIsResultFound((to && to.categories && to.categories.length > 0))

    searcherry.statisticService.sessionData.totalFound = to.totalFound ? to.totalFound : 0
    searcherry.statisticService.sessionData.maxRelevance = to.maxRelevance ? to.maxRelevance : 0
  }

  init (route: Route) {
    switch (route.name) {
      case 'main':
        this.searchPhrase = ''
        this.searchResults = []
        break

      case 'results':
        if (this.searchPhrase !== route.params.searchPhrase) {
          this.searchPhrase = route.params.searchPhrase
        }
        break

      case 'results-category':
        if (this.searchPhrase !== route.params.searchPhrase) {
          this.searchPhrase = route.params.searchPhrase
        }
        this.categoryId = parseInt(route.params.categoryId)
        break
    }
  }

  fetchData () {
    switch (this.$route.name) {
      case 'main':
        searchApiClient.abortRequest()
        break

      case 'results':
        this.searchResults.items = null
        searchApiClient.search(this.searchPhrase).then((data: any) => {
          if (!data || data.length === 0) {
            data = []
          }

          if (data.searchResultFields && data.searchResultFields.length > 0) {
            for (let key in data.searchResultFields) {
              if (data.searchResultFields.hasOwnProperty(key) && data.searchResultFields[key].indexOf('synonym') !== -1) {
                searcherry.statisticService.synonymsDictUsageEvent()
                break
              }
            }
          }

          if (data.categories && data.categories.length === 1) {
            this.$router.replace({
              name: 'results-category',
              params: {
                searchPhrase: this.searchPhrase,
                categoryId: data.categories[0].data.siteId
              }
            })
          } else {
            this.searchResults = data
          }
        })
        break

      case 'results-category':
        // this.searchResults.items = null

        let page = 1
        if (this.$route.query.hasOwnProperty('page')) {
          page = parseInt(this.$route.query['page'].toString())
          if (page < 1) {
            page = 1
          }
        }
        searchApiClient.searchCategory(this.searchPhrase, this.categoryId, page, searcherryConfig.categoryPageSize).then((data: any) => {
          if (!data || data.length === 0) {
            data = []
          }

          this.searchResults = data
        })
        break
    }
  }

  closeSearch (): void {
    let data = new ExitEventData()
    data.searchPhrase = this.searchPhrase
    searcherry.statisticService.exitWithCloseEvent(data)

    searcherry.generateEvent('before-close')
    let router = routerProvider.getRouter()
    router.push('/')
    searcherry.generateEvent('after-close')
  }

  backgroundClick (e: Event): void {
    if (e.target instanceof HTMLElement) {
      if (e.target.classList.contains('srchrry')) {
        this.closeSearch()
      }
    }
  }
}
